import _ from 'lodash';
import { defineStore } from 'pinia';

import { ICardSet, ILayoutSettings, ISerializedFlexibleLayoutItem } from '@/modules/layout-builder/types';
import { BASIC_COMPONENTS } from '@/constants';

export interface LocalLayoutSettings {
  readonly isUpdateAvailable?: boolean;
  /* Version < 3 */
  readonly version?: string;
  readonly items?: ISerializedFlexibleLayoutItem[];
}

/** TODO: Update! */
export const useUILayoutSettingsStore = defineStore('HITL-Settings-UI-Layout', {
  state: () => {
    return {
      areSettingsLoading: false,
      isSaving: false,
      defaultLayout: {} as ILayoutSettings,
      layout: {
        wasUpdated: false,
      } as ILayoutSettings & { wasUpdated: boolean; },
      local: {
        uiLayout: undefined as LocalLayoutSettings | undefined,
      },
      /* TODO: Move to a separate store? */
      cardComponentsSet: {} as ICardSet,
    };
  },
  getters: {
    layoutCardIds: state => {
      const basicComponentKeys = BASIC_COMPONENTS.map(c => c.key);
      let result = [] as string[];
      state.layout.workspaceList?.forEach(workspace => {
        result.push(...workspace.components);
      });
      result = _.uniq(result);
      result = _.difference(result, basicComponentKeys);
      return result;
    },
    layoutHeader: state => state.layout.header,
    layoutWorkspaceList: state => state.layout.workspaceList,
  },
});

export const useUILayoutSettingsSetters = () => {
  const store = useUILayoutSettingsStore();

  const setDefaultLayoutSettings = (settingsData: ILayoutSettings) => {
    store.defaultLayout = {
      ...store.defaultLayout,
      ...settingsData,
    };
  };

  const setCardComponentsSet = (cards: ICardSet) => {
    store.cardComponentsSet = cards;
  };

  const initializeLayoutSettings = (wasUpdated: boolean) => {
    const { workspaceList } = store.layout;
    store.layout = { ...store.layout, workspaceList, wasUpdated };
  };

  const updateLayoutSettings = (data: Partial<ILayoutSettings>) => {
    store.layout = { ...store.layout, ...data };
  };

  const resetLayoutSettings = () => {
    const defaultWorkspaceList = _.cloneDeep(store.defaultLayout.workspaceList);
    const workspaceList = defaultWorkspaceList.map(workspace => {
      const original = _.cloneDeep(workspace);
      return { ...workspace, original };
    });

    const layout = {
      ..._.cloneDeep(store.defaultLayout),
      workspaceList,
      wasUpdated: false,
    };

    Object.assign(store, { layout });
  };

  const updateLocalSettings = (local: { uiLayout?: LocalLayoutSettings; }) => {
    store.local = { ...store.local, ...local };
  };

  return {
    setDefaultLayoutSettings,
    setCardComponentsSet,
    initializeLayoutSettings,
    updateLayoutSettings,
    resetLayoutSettings,
    updateLocalSettings,
  };
};
